import digitalLogo from "../assets/logos/digitalProf-it.png";
import federacionLogo from "../assets/logos/Federacion_Cafeteros.png";
import seguroslogo from "../assets/logos/seguros_bolivar.png";
import fabellalogo from "../assets/logos/falabella.png";
import horizonLogo from "../assets/logos/Horizon.png";
import nettoLogo from "../assets/logos/NETTO.png";
import impulsapLogo from "../assets/logos/impulsap.png";
import mibancoLogo from "../assets/logos/mibanco.png";

export interface BusinessTheme {
  navBackground: string;
  navSolidColor: string;
  navTextColor: string;
  navBorder: string;
  dropdownBg: string;
  dropdownItemColor: string;
  dropdownHoverBg: string;
  dropdownHoverText: string;
  logo: string;
  logoFilter?: string;
  logoMaxHeight?: string;
  iconColor: string;
  iconHoverColor: string;
  tooltipBackground: string;
  buttonPrimary: string;
  isDarkLayout: boolean;
  pageBackground: string;
  cardBackground: string;
  welcomeSectionBg: string;
  welcomeTitleColor: string;
  welcomeSubtitleColor: string;
  cardTextColor: string;
  activeNavBg: string;
  activeNavText: string;
  profileBtnBg: string;
  profileBtnText: string;
}

const digitalTheme: BusinessTheme = {
  navBackground: "#151D20",
  navSolidColor: "#151D20",
  navTextColor: "#ffffff",
  navBorder: "#9BDD33",
  dropdownBg: "#ffffff",
  dropdownItemColor: "#151D20",
  dropdownHoverBg: "#e8f5d6",
  dropdownHoverText: "#151D20",
  logo: digitalLogo,
  logoMaxHeight: "38px",
  iconColor: "#9BDD33",
  iconHoverColor: "#ffffff",
  tooltipBackground: "#151D20",
  buttonPrimary: "#9BDD33",
  isDarkLayout: true,
  pageBackground: "#151D20",
  cardBackground: "#ffffff",
  welcomeSectionBg: "#ffffff",
  welcomeTitleColor: "#151D20",
  welcomeSubtitleColor: "#5a6a7a",
  cardTextColor: "#151D20",
  activeNavBg: "rgba(155,221,51,0.12)",
  activeNavText: "#9BDD33",
  profileBtnBg: "#9BDD33",
  profileBtnText: "#151D20",
};

const clientLightBase = (overrides: Partial<BusinessTheme>): BusinessTheme => ({
  isDarkLayout: false,
  pageBackground: overrides.navSolidColor ?? "#f4f6f9",
  cardBackground: "#ffffff",
  welcomeSectionBg: "#eceff3",
  welcomeTitleColor: "#2c3e50",
  welcomeSubtitleColor: "#5a6a7a",
  cardTextColor: "#2c3e50",
  activeNavBg: "#000000",
  activeNavText: "#ffffff",
  profileBtnBg: "#ffffff",
  profileBtnText: "#333333",
  dropdownHoverBg: "#f0f0f0",
  dropdownHoverText: "#333333",
  ...overrides,
} as BusinessTheme);

export const businessThemes: Record<number, BusinessTheme> = {
  1: digitalTheme,

  2: clientLightBase({
    navBackground: "#15913b",
    navSolidColor: "#15913b",
    navTextColor: "#FFFFFF",
    navBorder: "rgba(255,255,255,0.35)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#15913b",
    dropdownHoverBg: "#e8f4ec",
    dropdownHoverText: "#15913b",
    logo: mibancoLogo,
    logoMaxHeight: "44px",
    iconColor: "#15913b",
    iconHoverColor: "#106d2c",
    tooltipBackground: "#15913b",
    buttonPrimary: "#fad107",
  }),

  4: clientLightBase({
    navBackground: "#D3163B",
    navSolidColor: "#D3163B",
    navTextColor: "#FFFFFF",
    navBorder: "rgba(255,255,255,0.35)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#80142D",
    dropdownHoverBg: "#fce8ec",
    dropdownHoverText: "#80142D",
    logo: federacionLogo,
    logoMaxHeight: "40px",
    iconColor: "#80142D",
    iconHoverColor: "#D3163B",
    tooltipBackground: "#5A0F20",
    buttonPrimary: "#D3163B",
  }),

  3: clientLightBase({
    navBackground: "#048451",
    navSolidColor: "#048451",
    navTextColor: "#FFFFFF",
    navBorder: "rgba(255,255,255,0.35)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#048451",
    dropdownHoverBg: "#e8f5ee",
    dropdownHoverText: "#048451",
    logo: seguroslogo,
    logoMaxHeight: "44px",
    iconColor: "#048451",
    iconHoverColor: "#036b40",
    tooltipBackground: "#048451",
    buttonPrimary: "#FFD050",
  }),

  5: clientLightBase({
    navBackground: "#B6DE26",
    navSolidColor: "#B6DE26",
    navTextColor: "#1E364B",
    navBorder: "rgba(30,54,75,0.25)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#1E364B",
    dropdownHoverBg: "#f4f9e0",
    dropdownHoverText: "#1E364B",
    logo: fabellalogo,
    logoMaxHeight: "40px",
    iconColor: "#1E364B",
    iconHoverColor: "#B6DE26",
    tooltipBackground: "#1E364B",
    buttonPrimary: "#B6DE26",
  }),

  10: clientLightBase({
    navBackground: "#1a1a2e",
    navSolidColor: "#1a1a2e",
    navTextColor: "#FFFFFF",
    navBorder: "rgba(255,255,255,0.25)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#1a1a2e",
    dropdownHoverBg: "#eeeef5",
    dropdownHoverText: "#1a1a2e",
    logo: nettoLogo,
    logoMaxHeight: "40px",
    iconColor: "#1a1a2e",
    iconHoverColor: "#e94560",
    tooltipBackground: "#1a1a2e",
    buttonPrimary: "#e94560",
  }),

  12: clientLightBase({
    navBackground: "#003366",
    navSolidColor: "#003366",
    navTextColor: "#FFFFFF",
    navBorder: "rgba(255,255,255,0.25)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#003366",
    dropdownHoverBg: "#e6eef5",
    dropdownHoverText: "#003366",
    logo: horizonLogo,
    logoMaxHeight: "48px",
    iconColor: "#003366",
    iconHoverColor: "#0066cc",
    tooltipBackground: "#003366",
    buttonPrimary: "#0066cc",
  }),

  19: clientLightBase({
    navBackground: "#ff6600",
    navSolidColor: "#ff6600",
    navTextColor: "#FFFFFF",
    navBorder: "rgba(255,255,255,0.35)",
    dropdownBg: "#ffffff",
    dropdownItemColor: "#ff6600",
    dropdownHoverBg: "#fff0e6",
    dropdownHoverText: "#cc5200",
    logo: impulsapLogo,
    logoMaxHeight: "40px",
    iconColor: "#ff6600",
    iconHoverColor: "#ff8833",
    tooltipBackground: "#ff6600",
    buttonPrimary: "#ff6600",
  }),
};

export const getBusinessTheme = (
  rawGroupId: number | string | null | undefined
): BusinessTheme => {
  const id = Number(rawGroupId);
  return businessThemes[id] || businessThemes[1];
};

/** Logo por grupo de negocio (evita src vacío en la barra). */
export const getBusinessLogo = (
  rawGroupId: number | string | null | undefined
): string => getBusinessTheme(rawGroupId).logo;

export const getBusinessGroupName = (
  rawGroupId: number | string | null | undefined
): string => {
  const id = Number(rawGroupId);
  const names: Record<number, string> = {
    1: "Digital Profit",
    2: "Mi Banco",
    3: "Seguros Bolívar",
    4: "Federación Nacional de Cafeteros",
    5: "Falabella",
    10: "Netto",
    12: "Horizon",
    19: "Impulsap",
  };

  return names[id] || `Grupo ${id || ""}`.trim();
};
